module.exports = __webpack_public_path__ + "static/media/Wizard.3571e554.jpg";